import { QueryClient } from '@tanstack/react-query';

// The app-wide React Query client. Module-scoped (not created in main.tsx) so
// non-hook code — service-layer writes like approveFields — can invalidate
// caches at the write site instead of relying on every caller to remember.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
    },
  },
});
